//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MessageBox } from 'src/index';

export default {
  methods: {
    openAlert() {
      MessageBox.alert('操作成功!', '提示');
    },

    openConfirm() {
      MessageBox.confirm('确定执行此操作?', '提示');
    },

    openPrompt() {
      MessageBox.prompt(' ', '请输入姓名').then(({ value }) => {
        if (value) {
          MessageBox.alert(`你的名字是 ${ value }`, '输入成功');
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./example/pages/message-box.vue